export default __webpack_public_path__ + "static/media/icons8-add-folder-96.7a78b408.svg";